var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('HeaderNav',{ref:"header-nav",staticClass:"header-nav"}),_c('div',{ref:"wrapper",staticClass:"page-wrapper main-content"},[_c('SideBar'),_c('router-view'),_c('BottomNav',{staticClass:"bottom-nav"}),_c('Chatbot')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }